import { render, staticRenderFns } from "./production-order-detail.vue?vue&type=template&id=741efe06&scoped=true"
import script from "./production-order-detail.ts?vue&type=script&lang=ts&external"
export * from "./production-order-detail.ts?vue&type=script&lang=ts&external"
import style0 from "./production-order-detail.scoped.scss?vue&type=style&index=0&id=741efe06&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741efe06",
  null
  
)

export default component.exports